import React, { useEffect, useState } from "react";
import { useI18n } from "../i18n/I18nProvider";
import { Check } from "lucide-react";
import api from "../lib/api";

export default function Pricing({ onBook }) {
  const { t } = useI18n();
  const [pricing, setPricing] = useState({ half_day: 50, full_day: 85, multi_day: 70 });
  useEffect(() => {
    api.get(`/scooters/niu-nqix-500`).then(r => {
      const p = r.data?.pricing || {};
      setPricing({
        half_day: p.half_day ?? 50,
        full_day: p.full_day ?? 85,
        multi_day: p.multi_day ?? 70,
      });
    }).catch(() => {});
  }, []);
  const tiers = [
    { key: "half_day", title: t.pricing.half, price: pricing.half_day, suffix: t.pricing.flat, desc: t.pricing.half_desc, popular: false },
    { key: "full_day", title: t.pricing.full, price: pricing.full_day, suffix: t.pricing.per_day, desc: t.pricing.full_desc, popular: true },
    { key: "multi_day", title: t.pricing.multi, price: pricing.multi_day, suffix: t.pricing.per_day, desc: t.pricing.multi_desc, popular: false },
  ];
  const perks = ["Helmet · Casco · Helm", "ABS + TCS", "9 900 W"];
  return (
    <section id="pricing" className="relative py-24 sm:py-32 bg-[#050505]" data-testid="pricing-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="text-[11px] tracking-[0.35em] uppercase font-bold text-scooter-yellow mb-3">{t.pricing.label}</div>
          <h2 className="font-heading font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter">{t.pricing.title}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {tiers.map((tier) => (
            <div
              key={tier.key}
              className={`relative p-10 flex flex-col border transition-all ${tier.disabled ? "bg-[#0a0a0a] border-white/10 opacity-60" : `hover:-translate-y-1 ${tier.popular ? "bg-scooter-yellow text-black border-scooter-yellow" : "bg-[#0a0a0a] border-white/10 hover:border-white/30"}`}`}
              data-testid={`pricing-${tier.key}`}
            >
              {tier.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-black text-scooter-yellow text-[10px] tracking-[0.3em] uppercase font-bold px-3 py-1">{t.pricing.popular}</div>
              )}
              {tier.disabled && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-scooter-yellow text-black text-[10px] tracking-[0.3em] uppercase font-bold px-3 py-1" data-testid={`pricing-coming-soon-${tier.key}`}>{t.pricing.coming_soon || "In arrivo"}</div>
              )}
              <div className={`text-[10px] tracking-[0.3em] uppercase font-bold mb-4 ${tier.popular ? "text-black/70" : "text-zinc-500"}`}>{tier.title}</div>
              <div className="flex items-baseline gap-1 mb-2">
                <span className="font-heading font-black text-6xl tracking-tighter">€{tier.price}</span>
                <span className={`text-sm font-bold ${tier.popular ? "text-black/70" : "text-zinc-500"}`}>{tier.suffix.startsWith("/") ? tier.suffix : ` ${tier.suffix}`}</span>
              </div>
              <div className={`text-xs uppercase tracking-wider font-semibold mb-2 ${tier.popular ? "text-black/70" : "text-zinc-500"}`}>{t.pricing.per}</div>
              <p className={`text-sm mb-6 ${tier.popular ? "text-black/80" : "text-zinc-400"}`}>{tier.desc}</p>
              <ul className="space-y-2 mb-8 text-sm">
                {perks.map((p) => (
                  <li key={p} className="flex items-center gap-2">
                    <Check className={`w-4 h-4 ${tier.popular ? "text-black" : "text-scooter-yellow"}`} />
                    <span className={tier.popular ? "text-black" : "text-zinc-300"}>{p}</span>
                  </li>
                ))}
              </ul>
              {tier.disabled ? (
                <button disabled className="mt-auto h-12 px-6 text-xs font-bold tracking-[0.2em] uppercase border border-white/10 text-zinc-500 cursor-not-allowed" data-testid={`pricing-disabled-${tier.key}`}>{t.pricing.coming_soon || "In arrivo"}</button>
              ) : (
                <button
                  onClick={onBook}
                  className={`mt-auto h-12 px-6 text-xs font-bold tracking-[0.2em] uppercase transition-colors ${tier.popular ? "bg-black text-scooter-yellow hover:bg-zinc-900" : "border border-white/20 text-white hover:bg-white hover:text-black"}`}
                  data-testid={`pricing-book-${tier.key}`}
                >{t.nav.book}</button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
